import ModalComponent from "@/common/Modal";
import { OptInModalProps } from "../types";
import { Box, Button, Text, Switch, Divider } from "@chakra-ui/react";
import React, { useState, useEffect } from 'react'
import './OptInForm.scss';
import { getDealerActionsToBeSaved, getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
import { setDealerActionsToBeSaved, setIsCreateDealerActionInprogress, callToCreateDealerAction} from '@/explore/ducks/slice';
import { DealerProfileType } from '@masterffl/dealer-profile-component';

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { callToGetDealerDetail } from "../ducks/slice";

export function UpdateBigBoxRetailerForm({ data }: { data: DealerProfileType }) {  
  const dispatch = useDispatch();

  const isBigBoxRetailer = data?.primaryInboundDetails?.isBigBoxRetailer || false;
  const [bigBoxRetailer, setBigBoxRetailer] = useState<boolean>(isBigBoxRetailer)
  const [defaultStatus, setDefaultStatus] = useState(true);

  useEffect(()=>{
     dispatch(setDealerActionsToBeSaved([]))
  },[])
  
  useEffect(() => {
      dispatch(setDealerActionsToBeSaved([{
            name:'is_big_box_retailer' ,
            type: 'update',
            value: bigBoxRetailer,
            license_key: data?.primaryInboundDetails?.licenseKey || '',
            dealer_id: data?._id,
        }]));
  },[bigBoxRetailer])
 
  const onChangeBigBoxRetailer = (event:any) => {
    if (event.target.checked) setBigBoxRetailer(true)
    else setBigBoxRetailer(false);  
  }

  return (
    <Box>
      <Box className="update_preferences_text">
        <Text className="update_preferences_title">Update Big Box Retailer Status</Text>
      </Box>
      <Box className="toggle_section_wrapper">
         <Box className="toggle_section">
          <Text>Big Box Retailer</Text>
          <Switch color={'gray'} size='lg' onChange={(event: any) => {
            setDefaultStatus(false)
            onChangeBigBoxRetailer(event)
          }}
            isChecked={defaultStatus ? isBigBoxRetailer : bigBoxRetailer}
            sx={{
              '& .chakra-switch__track': { bg: '#d6d6d6' }, // Track color when unchecked
              '& .chakra-switch__thumb': { bg: 'white.600', border: '2px', borderColor: 'gray.300' }, // Thumb color when unchecked
              '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100', },
              '.chakra-switch__thumb[data-checked]:not([data-theme])': { backgroundColor: 'green.400', border: '2px', borderColor: 'green.100' },
            }}
          />
        </Box> 
      </Box>
      <Divider style={{ width: '90%', margin: 'auto' }} />
    </Box>
  );
}

export default function BigBoxRetailerModal({
  isOpen,
  onClose,
  data
}: OptInModalProps) {
  const dispatch = useDispatch()
  const params: any = useParams()
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted()

  const defaultValue = dealerActionsToBeSaved.map((item:any) => item.value)[0]
  const isBigBoxRetailer = data?.primaryInboundDetails?.isBigBoxRetailer || false;
  
  const onSaveHandler = async () => {
    dispatch(setIsCreateDealerActionInprogress(true))
    dispatch(callToCreateDealerAction({ actionList: dealerActionsToBeSaved }));
  };

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      dispatch(callToGetDealerDetail(params?.dealerId));
      onClose()
    }
  }, [isCreateDealerActionCompleted, isCreateDealerActionInprogress])

  return (
    <ModalComponent
      title="Big Box Retailer"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      className="btns"
      maxWidth="500px"
      footer={
        <Box className="opt-in-footer">
          <Button
            className="cancel_btn"
            onClick={() => {
              dispatch(setDealerActionsToBeSaved([]))  
              onClose();
            }}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            className="save_btn"
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isLoading={isCreateDealerActionInprogress}
            isDisabled={defaultValue === isBigBoxRetailer}
          >
            Save
          </Button>
        </Box>
      }

    >
      <UpdateBigBoxRetailerForm data={data} />

    </ModalComponent>
  )
}
